import { et as reactet } from '@ews/react-translations';

const et = {
...reactet
}
export default et
